import { Room } from "../Model/Room";
export class RoomsFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createRoom(id, enabled, integratedDisplay, pictureId, name, state, gallery, roomRewards) {
        return new Room(this.eventsChannelFactory, id, enabled, integratedDisplay, pictureId, name, state, gallery, roomRewards);
    }
}
